<template>
  <div class="filters-range-wrap--preloader">
    <div class="range-filter-wrap">
        <div class="range-filter-values">
        <span class="range-filter-input-empty shine"></span>
        <span class="range-filter-name" v-text="title"></span>
        <span class="range-filter-input-empty shine"></span>
        </div>
        <div class="range-filter-slider-empty"></div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type: String,
      default: 'Verð'
    }
  }
}
</script>
